"use client";

import { useEffect, useLayoutEffect, useState } from "react";

export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);

  useLayoutEffect(() => {
    if (typeof window !== undefined) setIsClient(true);
    else setIsClient(false);
  }, []);

  return isClient;
};
